<template>
  <v-dialog v-model="show" :max-width="400">
    <v-card>
      <v-container>
        <v-row justify="end" class="pr-2">
          <v-btn icon small @click="show=false">
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center pt-0">
            <v-icon color="green" style="font-size:60px">fa-check-circle</v-icon>
          </v-col>
          <v-col cols="12" class="text-center pt-0">
            <h3 class="font-weight-light">{{this.$store.state.website.applicant_success}}</h3>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ApplicantSuccess",
  created() {
    this.$eventBus.$on("applicant-success", this.handleEvent);
  },
  data() {
    return {
      show: false
    };
  },
  methods: {
    handleEvent() {
      this.show = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.logofont {
  font-family: "Arial Rounded MT Bold", sans-serif;
  font-size: 48px;
  letter-spacing: -2px;
}
</style>